import {Injectable} from "@angular/core";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {FormFieldGroupConfig} from "../../../model/api/form-field-group-config";
import {resolveFieldTypes} from "../../../utils/object-reflection";
import {
  BatchActionSupportOrderFormComponent
} from "../../../crystal-clear/support/order-crud/batch-update-form/batch-action-support-order-form.component";
import {SupportOrderDataLoadingService} from "./support-order-data-loading.service";
import {FieldRecord} from "../../../model/api/field-record";
import {Account} from "../../../model/clearing/account";
import {TableColumnConfig} from "../../../model/api/table-column-config";
import {TableColumnUtils} from "../../../utils/table-column-utils";
import {BatchFormUtils} from "../../../utils/batch-form-utils";
import {Order} from "../../../model/clearing/order";
import TYPE = FormFieldConfig.TYPE;
import {SupportOrderFormConfigService} from "./support-order-form-config.service";

@Injectable({
  providedIn: 'root'
})
export class SupportOrderBatchFormConfigService {

  /** fields selected for update */
  fieldsToUpdate: string[] = [];

  private readonly excludedFields = [
    'id',
    'account',
    'clearings',
    'clearingInfo'
  ];

  loadConfig(
    component: BatchActionSupportOrderFormComponent
  ): FormFieldGroupConfig[] {

    const tradeFields: FormFieldConfig[] =
      (Object.keys(new Order()) as Array<keyof Order>)
        .filter(f => BatchFormUtils.isEditable(f as string, this.excludedFields))
        .map(f =>
          BatchFormUtils.buildBatchField<Order>(
            f,
            SupportOrderFormConfigService.fieldTypes[f],
            this.fieldsToUpdate,
            component.ccFormDialog
          )
        );

    tradeFields.forEach(
      f => f.options = SupportOrderFormConfigService.buildOptions(f, component.dataLoadingService)
    );

    const accountFields: FormFieldConfig[] =
      (Object.keys(new Account()) as Array<keyof Account>)
        .filter(f => BatchFormUtils.isEditable(f as string, this.excludedFields))
        .map(f =>
          BatchFormUtils.buildBatchField<Account>(
            f,
            SupportOrderFormConfigService.fieldTypes[f],
            this.fieldsToUpdate,
            component.ccFormDialog,
            'account.'
          )
        );

    const accountColumns: TableColumnConfig[] =
      (Object.keys(new Account()) as Array<keyof Account>)
        .map(f =>
          TableColumnUtils.buildColumn<Account>(
            f,
            SupportOrderFormConfigService.fieldTypes[f]
          )
        );

    return [
      {
        group: 'account',
        fields: [
          {
            field: 'account',
            column: 12,
            type: TYPE.SINGLERICHFIELD,
            richFieldConfig: {
              fieldId: 'name',
              fieldName: 'name',
              tableConfigs: accountColumns,
              fields: [{ group: '', fields: accountFields }]
            }
          }
        ]
      },
      {
        group: 'fields',
        fields: tradeFields
      }
    ];
  }

}
